import React from "react";
import styles from "./CTAThree.module.css";
import CTAImage from "../../Assets/frontendImages/CTA.svg";
import { Link } from "react-router-dom";
import Description from "./Description";
import Colors from "../../Constants/Colors";
import Heading from "./Heading";

const CTAThree = ({ customHeading, customDescription }) => {
  return (
    <div style={{backgroundColor:Colors.bgColorFrontend}}>
    <div
      className="container-fluid py-5">
      <div className="row align-items-center text-white">
        {/* Left side */}
        <div className="col-md-7 text-center text-md-start px-3 px-sm-4">
          <Heading className="text-white mb-3 text-center text-md-start">
          {customHeading || "Join Over 10,000+ Businesses and Freelancers Growing With Zodot"}
          </Heading>
          <Description className="text-white mb-4">
          {customDescription || "From freelancers to fast-growing teams, thousands trust Zodot to manage projects, clients, and finances — all in one powerful platform."}          </Description>

          <div
            className="d-flex justify-content-center justify-content-md-start w-100"
          >
            <Link
              className={styles.more_button}
              style={{ textDecoration: "none" }}
              to="/db/signup"
            >
              Join us Now
            </Link>
          </div>
        </div>

        {/* Right side */}
        <div className="col-md-5 text-center mt-4 mt-md-0 position-relative">
          {/* Main logo */}
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-4"
          >
            <img src={CTAImage} alt="Zodot" className="img-fluid" />
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default CTAThree;
